import React from 'react';
import styles from '@dazn/lp-web/src/components/SpotlightRail/spotlight.module.css';
import StaticImage from '@dazn/lp-web/src/components/Images/ImageComponent/Image';
import {animated} from '@react-spring/web';
import {useSpotlightTransitions} from '@dazn/lp-web/src/hooks/useTransitions';
import {ISpotlightRail} from '@dazn/lp-web/src/types/rail.types';
import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';
import Markdown from 'markdown-to-jsx';

interface IProps {
    rail: ISpotlightRail;
    disableAnimation: boolean;
    isBackgroundImageAvailable: boolean;
}

const SpotlightRailContent: React.FC<IProps> = ({
    rail,
    disableAnimation,
    isBackgroundImageAvailable
}) => {
    const [refView, springs] = useSpotlightTransitions();
    const animations = disableAnimation
        ? {}
        : {
              style: springs,
              ref: refView
          };

    return (
        <>
            <animated.div className={styles.container} {...animations}>
                <Markdown
                    className={styles.title}
                    data-target="title"
                    options={{
                        forceBlock: true
                    }}
                >
                    {rail?.title}
                </Markdown>
                <Markdown
                    className={styles.description}
                    data-target="description"
                    options={{
                        forceBlock: true
                    }}
                >
                    {rail?.description}
                </Markdown>
            </animated.div>
            {isBackgroundImageAvailable && (
                <>
                    <StaticImage
                        image={rail.image}
                        alt="Spotlight Background Image"
                        componentType={ComponentTypes.SPOTLIGHT_RAIL}
                        showPlaceHolderImage
                    />
                    <div className={styles.overlay} />
                </>
            )}
        </>
    );
};

export default SpotlightRailContent;
